var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "image-attribution" }, [
    _c("div", { staticClass: "image-attribution-inner" }, [
      _vm.authorDescription
        ? _c("div", { staticClass: "description" }, [
            _vm._v("\n      " + _vm._s(_vm.authorDescription) + "\n    "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.authorInfo
        ? _c("div", { staticClass: "preposition" }, [
            _vm._v("\n      by\n    "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", {
        staticClass: "author",
        domProps: { innerHTML: _vm._s(_vm.authorInfo) },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }